export const MOBILE = 450;
export const TABLET = 768;
export const LAPTOP = 1068;
export const DESKTOP = 1440;
